import type { Transition, Variants } from 'framer-motion';

// 新UIの動きはここに集める。画面ごとに値を作らない。
export const spring: Transition = { type: 'spring', stiffness: 420, damping: 34, mass: 0.8 };
export const softSpring: Transition = { type: 'spring', stiffness: 220, damping: 26 };
export const ease = [0.22, 1, 0.36, 1] as const;

export const pageVariants: Variants = {
  initial: { opacity: 0, y: 14, filter: 'blur(6px)' },
  enter: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    // blur(0px) が残ると、中の position: fixed の板（旧部品のモーダルなど）がこの要素を基準にずれる
    transitionEnd: { filter: 'none' },
    transition: { duration: 0.45, ease, when: 'beforeChildren', staggerChildren: 0.06 },
  },
  exit: { opacity: 0, y: -8, filter: 'blur(4px)', transition: { duration: 0.2, ease } },
};

export const stagger = (gap = 0.05, delay = 0): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: gap, delayChildren: delay } },
});

export const riseIn: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease } },
};

export const popIn: Variants = {
  hidden: { opacity: 0, scale: 0.92, filter: 'blur(8px)' },
  show: { opacity: 1, scale: 1, filter: 'blur(0px)', transition: { duration: 0.55, ease } },
};

export const slideX = (dir: 1 | -1): Variants => ({
  hidden: { opacity: 0, x: 24 * dir },
  show: { opacity: 1, x: 0, transition: { duration: 0.35, ease } },
  exit: { opacity: 0, x: -24 * dir, transition: { duration: 0.2, ease } },
});

export const titleChar: Variants = {
  hidden: { y: '110%', opacity: 0 },
  show: { y: '0%', opacity: 1, transition: { duration: 0.55, ease } },
};

/** 後から現れる枠。中の Section へ hidden/show をそのまま渡す */
export const reveal: Variants = {
  hidden: { opacity: 0, height: 0 },
  show: { opacity: 1, height: 'auto', transition: { duration: 0.35, ease, when: 'beforeChildren' } },
};

export const tapScale = { scale: 0.97 };
export const hoverLift = { y: -4 };
